function resolveApiBase() {
  if (typeof window !== "undefined") {
    const h = window.location.hostname;
    const isKaisoOrigin =
      h === "kaisosystem.com" ||
      h.endsWith(".kaisosystem.com") ||
      h === "localhost" ||
      h === "127.0.0.1" ||
      h.endsWith(".onrender.com") ||
      h.endsWith(".emergent.host") ||
      h.endsWith(".preview.emergentagent.com");
    if (!isKaisoOrigin) {
      return (
        process.env.REACT_APP_BACKEND_URL ||
        process.env.REACT_APP_API_BASE ||
        "https://api.kaisosystem.com"
      );
    }
  }
  return (
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_BASE ||
    "https://api.kaisosystem.com"
  );
}

const API_BASE = resolveApiBase();

export default API_BASE;
